import styled from 'styled-components'
import { theme } from '../WordStat/common'

export const PieChartContainer = styled.div`
  display: flex;
  gap: 20px;

  @media (max-width: 999px) {
    gap: 8px;
  }

  @media (max-width: 767px) {
    flex-direction: column;
  }
`

export const Title = styled.h2`
  margin: 0;
  margin-bottom: 8rem !important;
  font-size: 42px;
  line-height: 48px;
  font-weight: 400;
  color: ${theme.palette.black(20)};

  @media (max-width: 1279px) {
    margin-bottom: 6rem !important;
    font-size: 3.6rem;
    line-height: 4.2rem;
  }

  @media (max-width: 767px) {
    margin-bottom: 4rem !important;
    font-size: 3rem;
    line-height: 3.6rem;
  }
`
